import { render } from "./BankAccount.vue?vue&type=template&id=1b8a420b&scoped=true"
import script from "./BankAccount.vue?vue&type=script&lang=js"
export * from "./BankAccount.vue?vue&type=script&lang=js"

import "./BankAccount.vue?vue&type=style&index=0&id=1b8a420b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8a420b"]])

export default __exports__